import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import InspectionItem from '../InspectionItem'
// Constants
import AssignBox from '../../../NewWorkscreen/AssignBox'
import AssignItem from '../../../NewWorkscreen/AssignItem'
import { translation } from '../../../../utils/helpers'

// Elements
import Button from '../../../../shared/elements/button'

class AssignWorker extends Component {

  constructor (props) {
    super(props)
    this.state = {
      showAssign: false
    }
    this.renderContent = this.renderContent.bind(this)
    this.onAssignUsers = this.onAssignUsers.bind(this)
  }

  componentDidMount () {
  }

  onAssignUsers () {
    this.refs.AssignBox.getWrappedInstance().getAssignEmployees()
  }
  renderContent () {
    if (this.props.order.StepId === undefined) return null // Order not loaded yet.
    if (this.props.isBodyshop) return null // TODO: Make processtime work for bodyshop first
    const disabled = this.props.order.IsReferredOut
    let stepId = this.props.order.StepId
    // Find entry in step assignments
    let entry = null
    for (let i = 0; i < this.props.StepAssignments.length; i++) {
      if (this.props.StepAssignments[i].StepId === stepId) {
        entry = { ...this.props.StepAssignments[i].OrderAssignments[0] }
        break
      }
    }

    const toggleShowAssign = () => {
      let showAssign = !this.state.showAssign
      console.log(this.props, stepId, entry)
      this.setState({
        showAssign: showAssign
      })
    }
    return (
      <div>
        <AssignItem disabled={disabled} item={entry} step={stepId} onAssignUsers={this.onAssignUsers} assignAriaPos={'bottom-right'} DontShowDeadline />
        <Button style='secondary' onClick={toggleShowAssign} labelText={translation('270')} />
        {/* <img src='/images/svgs/inspection/add-white.svg' /> */}
      </div>)
  }
  render () {
    let title = { icon: '/images/svgs/inspection/assign.svg', text: '1856' }
    return (
      <div key='box_1'>
        <InspectionItem title={title} renderContent={this.renderContent} showCheckmark={false} />
        {this.state.showAssign && <AssignBox router={this.props.router} ref='AssignBox' onEmployeeChange={this.props.getAssignOrderData} closeAssign={() => { this.setState({ showAssign: false }) }} />}
      </div>
    )
  }
}

AssignWorker.defaultProps = {
  isBodyshop: false
}

AssignWorker.propTypes = {
  isBodyshop: PropTypes.bool,
  getAssignOrderData: PropTypes.func.isRequired,
  StepAssignments: PropTypes.array.isRequired,
  order: PropTypes.object.isRequired
}

AssignWorker.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(AssignWorker)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/AssignWorker/index.js